//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.CurveLengthData.js";
import "../no/EndCutBlockBuilder.js";
import "../no/Section.js";
import "../Features/Features.SelectFeatureList.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
import "../no/EndCutBlockBuilder.js";
let d=[[[1,"AngleOfRotation",0,"Expression",0],[0,"AngularTolerance",1,0],[0,"AttributeMaterial",1,0],[0,"AttributeName",1,0],[0,"BeltAlignment",1,0],[0,"BeltSize",1,0],[0,"BeltType",1,0],[1,"CurveLengthData",0,"GeometricUtilities.CurveLengthData",0],[0,"DistanceTolerance",1,0],[0,"EndCutType",1,0],[1,"EndEndCutBlock",0,"EndCutBlockBuilder",0],[1,"FaceOffsetExpression",0,"Expression",0],[0,"FaceOffsetVector",1,0],[1,"GuideOffsetExpression",0,"Expression",0],[0,"GuideOffsetVector",1,0],[1,"GuideSection",0,"Section",0],[0,"KeepFace",1,0],[0,"KeepGuide",1,0],[0,"OrientType",1,0],[0,"OrientationVector",1,"Direction",0],[1,"PlateHeight",0,"Expression",0],[1,"PlateWIdth",0,"Expression",0],[0,"ProfileSize",1,0],[0,"ProfileType",1,0],[0,"SectionType",1,0],[1,"SelectCsys",0,"Features.SelectFeatureList",0],[1,"SelectFace",0,"ScCollector",0],[1,"StartEndCutBlock",0,"EndCutBlockBuilder",0],[0,"Type",1,0]],[[["num_names"],"GetAvailableAttributeNames",{R_:{names:""}},0,0],[["num_materials"],"GetAvailableAttributeMaterials",{R_:{materials:""}},0,0],[["nBeltTypes"],"GetAvailableBeltTypes",{R_:{beltTypes:""}},0,0],[["nBeltSizes"],"GetAvailableBeltSizes",{R_:{beltSizes:""}},0,0],[["nProfileTypes"],"GetAvailableProfileTypes",{R_:{profileTypes:""}},0,0],[["nProfileSizes"],"GetAvailableProfileSizes",{R_:{profileSizes:""}},0,0]],[]];
SPLM.Features.ShipDesign.ProfileBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ProfileBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ProfileBuilder.TypeOption = Object.freeze({
    "Profile" : "Profile", "Belt" : "Belt"});

SPLM.Features.ShipDesign.ProfileBuilder.SectionOption = Object.freeze({
    "Plate" : "Plate", "Profile" : "Profile"});

SPLM.Features.ShipDesign.ProfileBuilder.OrientationOption = Object.freeze({
    "FaceNormal" : "FaceNormal", "DatumCsys" : "DatumCsys", "Vector" : "Vector"});

SPLM.Features.ShipDesign.ProfileBuilder.Alignment = Object.freeze({
    "Center" : "Center", "GuideEdge" : "GuideEdge", "OppositeGuide" : "OppositeGuide"});

SPLM.Features.ShipDesign.ProfileBuilder.EndCutOption = Object.freeze({
    "None" : "None", "Symmetric" : "Symmetric", "TwoSided" : "TwoSided"});

export default SPLM;